import Header from './Components/Header';
import Navigation from './Components/Navigation';
import Hero from './Components/Hero';
import About from './Components/About';
import Services from './Components/Services';
import Stats from './Components/Stats';
import Publications from './Components/Publications';
import Contact from './Components/Contact';
import Footer from './Components/Footer';
import RevealOnScroll from './Components/RevealOnScroll';

function App() {
  return (
    <div className="App">
      <Navigation />
      <Header />

      <RevealOnScroll>
        <About />
      </RevealOnScroll>

      <RevealOnScroll>
        <Services />
      </RevealOnScroll>

      <RevealOnScroll>
        <Stats />
      </RevealOnScroll>

      <RevealOnScroll>
        <Publications />
      </RevealOnScroll>

      <RevealOnScroll>
        <Contact />
      </RevealOnScroll>

      <Footer />
    </div>
  );
}

export default App;
